module.exports = __webpack_public_path__ + "static/media/face_angry.6ade04f5.svg";